import { createStyles, makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles(() =>
  createStyles({
    container: {
      border: '1px solid #C2000080',
      borderRadius: 4,
      margin: '1.2rem 0 1.6rem',
      padding: '0.4rem 0.8rem',

      display: 'flex',
      gap: '0.8rem',
      alignItems: 'start',

      '& > p': {
        color: '#BA1B1B',
        fontSize: '1.4rem',
        fontWeight: 600,
      },
      '& > svg': {
        color: '#BA1B1B',
        width: '1.8rem',
        marginTop: -2,
        marginRight: '0.6rem',
      },
    },
    list: {
      padding: 0,
      margin: 0,
      marginTop: 2,
      listStyle: 'none',

      '& > li': {
        color: '#BA1B1B',
        fontSize: '1.4rem',
        lineHeight: '1.6rem',

        '&:not(:first-child)': {
          marginTop: '0.6rem',
        },
      },
    },
  }),
)
